<template>
  <div class="p-16px">
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      title="紫金山骑手机构端 · 运单监控：释放到自由池、机构内改派、骑手硬约束。"
    />

    <el-form inline class="mb-12px">
      <el-form-item label="机构 ID">
        <el-input v-model="orgId" class="!w-120px" />
      </el-form-item>
      <el-form-item label="运单号">
        <el-input v-model="waybillId" class="!w-220px" placeholder="wb_…" />
      </el-form-item>
      <el-form-item label="改派给">
        <el-input v-model="toPhone" class="!w-140px" placeholder="手机号" />
      </el-form-item>
      <el-button type="warning" @click="onRelease">释放到自由池</el-button>
      <el-button @click="onT1">模拟 T1 超时</el-button>
      <el-button type="primary" @click="onReassign">机构内改派</el-button>
      <el-button type="danger" @click="onCancel">取消（可空跑）</el-button>
    </el-form>

    <el-row :gutter="16">
      <el-col :span="12">
        <el-card shadow="never" header="骑手硬约束">
          <el-form label-width="100px">
            <el-form-item label="骑手手机">
              <el-input v-model="riderPhone" />
            </el-form-item>
            <el-form-item label="改派对象">
              <el-input v-model="forceToPhone" placeholder="强制停用时必填" />
            </el-form-item>
            <el-button @click="onOffline">尝试下线</el-button>
            <el-button @click="onDeactivate">静默停用</el-button>
            <el-button type="danger" @click="onForce">强制停用并改派</el-button>
          </el-form>
          <el-divider />
          <el-form-item label="消息手机">
            <el-input v-model="msgPhone" class="!w-160px" />
            <el-button class="ml-8px" @click="loadMsgs">刷新消息</el-button>
          </el-form-item>
          <ul class="text-13px">
            <li v-for="(m, i) in messages" :key="i">{{ m }}</li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never">
          <template #header>
            <div class="flex justify-between">
              <span>规则 · T1 与审计</span>
              <el-button link type="primary" @click="loadAudits">刷新</el-button>
            </div>
          </template>
          <el-form inline>
            <el-form-item label="T1 秒">
              <el-input-number v-model="t1" :min="1" />
            </el-form-item>
            <el-button @click="onSaveT1">保存并记审计</el-button>
          </el-form>
          <el-table :data="audits" size="small" border max-height="360">
            <el-table-column prop="action" label="动作" width="140" />
            <el-table-column prop="actor" label="操作方" width="100" />
            <el-table-column prop="waybillId" label="运单" min-width="120" />
            <el-table-column prop="detail" label="详情" min-width="160" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts" setup>
import * as DispatchApi from '@/api/capacity/org-dispatch'
import { ElMessage } from 'element-plus'

defineOptions({ name: 'MerchantCapacityDispatch' })

const orgId = ref(localStorage.getItem('capacityOrgId') || '')
const waybillId = ref('')
const toPhone = ref('')
const riderPhone = ref('13900000005')
const forceToPhone = ref('13900000006')
const msgPhone = ref('13900000005')
const messages = ref<string[]>([])
const audits = ref<DispatchApi.AuditEvent[]>([])
const t1 = ref(180)

const tip = (r: DispatchApi.DispatchActResult, ok: string) => {
  if (!r.success) ElMessage.error(r.message || '失败')
  else ElMessage.success(ok)
  loadAudits()
}

const onRelease = async () =>
  tip(await DispatchApi.releaseToPool(waybillId.value, orgId.value), '已释放到自由池')
const onT1 = async () => tip(await DispatchApi.overflowT1(waybillId.value), 'T1 溢出')
const onReassign = async () =>
  tip(await DispatchApi.reassign(orgId.value, waybillId.value, toPhone.value), '已改派')
const onCancel = async () => tip(await DispatchApi.cancelWaybill(waybillId.value), '已取消')
const onOffline = async () => tip(await DispatchApi.goOffline(riderPhone.value), '已下线')
const onDeactivate = async () =>
  tip(await DispatchApi.deactivateSilent(orgId.value, riderPhone.value), '已停用')
const onForce = async () =>
  tip(
    await DispatchApi.forceDeactivate(orgId.value, riderPhone.value, forceToPhone.value),
    '强制停用并改派'
  )

const loadMsgs = async () => {
  messages.value = await DispatchApi.listMessages(msgPhone.value)
}
const loadAudits = async () => {
  audits.value = await DispatchApi.listAudits()
}
const onSaveT1 = async () => tip(await DispatchApi.setT1(t1.value), 'T1 已更新')

onMounted(async () => {
  if (!orgId.value) {
    orgId.value = localStorage.getItem('capacityOrgId') || ''
  }
  try {
    const r = await DispatchApi.getT1()
    t1.value = r.t1Seconds
  } catch {
    // ignore
  }
  await loadAudits()
})
</script>
